// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sequence-places {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    gap: 10px;
}


.sequence-place-column {
    flex: 1 1;
    min-width: 0;
}


/* =========================================
   Champ
   ========================================= */

.sequence-place-field {
    margin-bottom: 2px;
}


/* =========================================
   Label
   ========================================= */

.sequence-place-label {
    height: 20px;
    color: #dddddd;
    font-size: 12px;
    line-height: 20px;
}


/* =========================================
   Input
   ========================================= */

.sequence-place-field input {
    width: 100%;
    height: 20px;
    box-sizing: border-box;
    background: #202020;
    color: #eeeeee;
    border: 1px solid #808080;
    padding: 3px 5px;
    font-size: 12px;
    outline: none;
}


.sequence-place-field input:focus {
    border-color: #9292ff;
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/sequences/sequenceplaces.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,SAAS;AACb;;;AAGA;IACI,SAAO;IACP,YAAY;AAChB;;;AAGA;;8CAE8C;;AAE9C;IACI,kBAAkB;AACtB;;;AAGA;;8CAE8C;;AAE9C;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;;AAGA;;8CAE8C;;AAE9C;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;;AAGA;IACI,qBAAqB;AACzB","sourcesContent":[".sequence-places {\n    display: flex;\n    width: 100%;\n    box-sizing: border-box;\n    gap: 10px;\n}\n\n\n.sequence-place-column {\n    flex: 1;\n    min-width: 0;\n}\n\n\n/* =========================================\n   Champ\n   ========================================= */\n\n.sequence-place-field {\n    margin-bottom: 2px;\n}\n\n\n/* =========================================\n   Label\n   ========================================= */\n\n.sequence-place-label {\n    height: 20px;\n    color: #dddddd;\n    font-size: 12px;\n    line-height: 20px;\n}\n\n\n/* =========================================\n   Input\n   ========================================= */\n\n.sequence-place-field input {\n    width: 100%;\n    height: 20px;\n    box-sizing: border-box;\n    background: #202020;\n    color: #eeeeee;\n    border: 1px solid #808080;\n    padding: 3px 5px;\n    font-size: 12px;\n    outline: none;\n}\n\n\n.sequence-place-field input:focus {\n    border-color: #9292ff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
